import {World} from "./World";

export default class Settings {
  Accuracy = 0;
  ActivationDistance = 0;
  Bluetooth = false;
  CompassLimit = 0;
  Emergency_Message_Android = "";
  Emergency_Message_iOS = "";
  Min_Android_Version = 0;
  Min_iOS_Version = 0;
  ParkBoundaryThreshold = 0;
  ParkBoundaryWarningDismissTime = 0;
  StepCounter = 0;
  Worlds: { [WorldId: string]: World } = {};
}
